/**
 * One area, in the frame the settings pages use: the navigation on the left, and a
 * title with its sections separated by rules.
 */

import { Typography } from "@/components/ui/typography"
import * as m from "motion/react-m"
import type { HelpCategory, HelpContent } from "../api/types"
import { PAGE_ENTER } from "../motion"
import { HelpdeskArticleSidebar } from "./HelpdeskArticleSidebar"
import { ArticleList, ArticleRow } from "./HelpdeskCards"

export function HelpdeskCategoryPage({
  content,
  category,
}: {
  content: HelpContent
  category: HelpCategory
}) {
  return (
    <div className="@container flex h-full min-h-0 min-w-0">
      <HelpdeskArticleSidebar
        content={content}
        activeCategoryId={category.id}
      />

      {/* Keyed: a new area starts at its top. */}
      <div key={category.id} className="min-w-0 flex-1 overflow-y-auto">
        <m.div
          {...PAGE_ENTER}
          className="mx-auto flex w-full max-w-3xl flex-col gap-6 px-4 py-6 md:px-10 md:py-10"
        >
          <div className="flex flex-col gap-1">
            <Typography as="h3" role="heading" aria-level={1}>
              {category.title}
            </Typography>
            <Typography as="muted">{category.description}</Typography>
          </div>

          <div className="flex flex-col divide-y">
            {category.groups.map((group) => (
              <section
                key={group.id}
                className="flex flex-col gap-2 py-6 first:pt-0 last:pb-0"
              >
                <Typography as="large" role="heading" aria-level={2}>
                  {group.title}
                </Typography>
                <ArticleList>
                  {group.articles.map((article) => (
                    <ArticleRow
                      key={article.id}
                      article={article}
                      categoryId={category.id}
                    />
                  ))}
                </ArticleList>
              </section>
            ))}
          </div>
        </m.div>
      </div>
    </div>
  )
}
